import { useRef } from 'react';

import { Divider } from '@material-ui/core';

import PropTypes from 'prop-types';

import { Section, SectionAlternate } from '@/src/components/organisms';
import { scroller } from '@/src/lib/utils';

import { About, Features, Hero, Jobs, Newsletter } from './components';
import { features } from './data';

function CareerListingMinimal(props) {
  const { doc } = props;

  const jobsRef = useRef();

  const { jobs = {} } = doc || {};

  const scrollToRef = ref => setTimeout(() => scroller(ref.current.offsetTop - 200), 500);

  return (
    <div>
      <Hero />
      <Section>
        <About onJobsList={() => scrollToRef(jobsRef)} />
      </Section>
      <Features data={features} />
      <SectionAlternate>
        <div ref={jobsRef}>
          <Jobs data={jobs} />
        </div>
      </SectionAlternate>
      <Section>
        <Newsletter />
      </Section>
      <Divider />
    </div>
  );
}

CareerListingMinimal.propTypes = {
  doc: PropTypes.object,
};

export default CareerListingMinimal;
